import VideoAttribution, { videoPath } from "@/components/VideoAttribution";
import EmptyState from "@/components/EmptyState";
import MediaImage from "@/components/MediaImage";
import { isDemoMedia } from "@/lib/media";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Zap } from "lucide-react";
import { formatNumber, classNames } from "@/lib/format";

export default function CompareColumn({ profile, side, color }) {
  const bar = color === "rose" ? "bg-[hsl(var(--rose))]" : "bg-primary";
  const maxDay = Math.max(...profile.weekday.map((d) => d.videos), 1);
  return (
    <Card className="p-5 space-y-5" data-testid={`compare-column-${side}`}>
      <div>
        <h4 className="font-display font-bold text-base mb-1">Hook mix</h4>
        <p className="text-xs text-muted-foreground mb-3">Which openers {profile.creator.name.split(" ")[0]} leans on.</p>
        <div className="space-y-2">
          {profile.hook_mix.slice(0, 6).map((h) => (
            <div key={h.name}>
              <div className="flex items-center justify-between text-xs">
                <span className="font-medium truncate">{h.name}</span>
                <span className="font-mono text-muted-foreground">
                  {h.share_pct}%{h.outliers > 0 && <span className="text-[hsl(var(--emerald))] ml-1.5 inline-flex items-center gap-0.5"><Zap className="h-3 w-3" />{h.outliers}</span>}
                </span>
              </div>
              <div className="mt-1 h-1.5 rounded-full bg-muted overflow-hidden">
                <div className={classNames("h-full rounded-full", bar)} style={{ width: `${h.share_pct}%` }} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h4 className="font-display font-bold text-base mb-3">Posting rhythm</h4>
        <div className="flex items-end gap-1.5 h-16">
          {profile.weekday.map((d) => (
            <div key={d.day} className="flex-1 flex flex-col items-center gap-1">
              <div className={classNames("w-full rounded-t", bar, d.videos === 0 && "opacity-20")} style={{ height: `${Math.max((d.videos / maxDay) * 48, 3)}px` }} />
              <span className="text-[10px] text-muted-foreground">{d.day}</span>
            </div>
          ))}
        </div>
      </div>

      <div>
        {/* compare.py top_videos: the three highest outlier multipliers, outliers or not. */}
        <h4 className="font-display font-bold text-base">Multiplicateurs les plus élevés</h4>
        <p className="text-[11px] text-muted-foreground mb-3" data-testid={`compare-${side}-top-scope`}>Trois vidéos au plus, outliers ou non.</p>
        {!profile.top_videos.length && <EmptyState testid={`compare-${side}-videos-empty`} level={3} title="Aucune vidéo disponible pour ce créateur" primaryCta={{ label: "Consulter Creators", to: "/creators", testid: `compare-${side}-videos-empty-cta` }} />}
        <div className="space-y-1.5">
          {profile.top_videos.map((v) => (
            <Link key={v.id} to={videoPath(v)} className="flex items-center gap-3 rounded-md bg-muted/40 px-2 py-1.5 hover:bg-muted transition-colors">
              <MediaImage src={v.thumbnail} alt="" demo={isDemoMedia(v, profile.creator)} showLabel={false} className="h-10 w-8 rounded object-cover" />
              <div className="flex-1 min-w-0">
                <div className="text-xs font-medium truncate">{v.title}</div>
                <VideoAttribution video={v} />
                <div className="text-[10px] text-muted-foreground">{v.hook_style} · {formatNumber(v.views)} views</div>
              </div>
              <div className={classNames("font-mono text-xs font-bold", v.is_outlier ? "text-[hsl(var(--emerald))]" : "text-muted-foreground")}>{v.outlier_multiplier.toFixed(1)}x</div>
            </Link>
          ))}
        </div>
      </div>
    </Card>
  );
}
